// extracted by mini-css-extract-plugin
export var button = "_48-7";
export var buttonRow = "_48-6";
export var fadeIn = "_48-1";
export var gradient = "_48-0";
export var panel = "_48-2";
export var panelIn = "_48-3";
export var subtitle = "_48-5";
export var title = "_48-4";